module.exports = "static/assets/389413b8fe5b7cd8a377e63724207ed8.png";